import { useNavigate } from "react-router-dom";
import SidebarIcon from '../../../../assets/index'

export default function Inicial() {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen flex flex-col items-center justify-center bg-white">
			<div className="w-full flex flex-col items-center pt-8">
				<SidebarIcon iconName={"Geppro_Seller"} className="h-8 w-auto mt-5 mb-10" />

				<div className="flex items-center justify-center gap-3 mb-20">
					<button
						onClick={() => navigate('/create-store/step1')}
						className="bg-purple-600 text-white px-100 h-9 rounded-lg w-64 flex items-center justify-center text-sm shadow-sm"
					>
						+ Criar a minha loja
					</button>

					<button
						aria-label="profile"
						onClick={() => navigate('/conta-do-vendedor')}
						className="bg-gray-100 w-10 h-9 rounded-lg flex items-center justify-center text-gray-600 shadow-sm"
					>
						<SidebarIcon iconName={"person"} className="h-5 w-auto mb-0.2"/>
					</button>
				</div>
			</div>

			<main className="flex-1 items-center justify-center relative">
				<div className="max-w-sm w-full text-center">
					<div className="flex items-center justify-center mb-5">
						<SidebarIcon iconName={"Homem_olhando_escultura"} />
					</div>

					<h2 className="text-xl font-semibold mb-2">Quase lá!</h2>
					<p className="text-gray-600">
						Você precisa criar uma loja para acessar os recursos da plataforma.
					</p>
				</div>
			</main>
		</div>
	);
}
